import * as React from "react";
import AuthorTeaser, { AuthorTeaserProps } from "~/components/author-teaser/author-teaser";

export interface IAuthorTeaserViewProps {
    contextModel: AuthorTeaserProps;
}

class AuthorTeaserView extends React.PureComponent<IAuthorTeaserViewProps> {
    public render() {
        return <AuthorTeaser {...this.props.contextModel} />;
    }
}

export default AuthorTeaserView;
